// This file is auto-generated. Do not edit!

export default [
  {
    address: "0x0D8775F648430679A709E98d2b0Cb6250d2887EF",
    symbol: "BAT",
    gemJoin: "0x3D0B1912B66114d4096F48A8CEe3A56C231772cA",
    ilkDescription: "BAT_A",
    ilk: "0x4241542d41000000000000000000000000000000000000000000000000000000",
  },
  {
    address: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
    symbol: "COMP",
    gemJoin: "0xBEa7cDfB4b49EC154Ae1c0D731E4DC773A3265aA",
    ilkDescription: "COMP_A",
    ilk: "0x434f4d502d410000000000000000000000000000000000000000000000000000",
  },
  {
    address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    symbol: "WETH",
    gemJoin: "0x2F0b23f53734252Bda2277357e97e1517d6B042A",
    ilkDescription: "ETH_A",
    ilk: "0x4554482d41000000000000000000000000000000000000000000000000000000",
  },
  {
    address: "0xdd974D5C2e2928deA5F71b9825b8b646686BD200",
    symbol: "KNC",
    gemJoin: "0x475F1a89C1ED844A08E8f6C50A00228b5E59E4A9",
    ilkDescription: "KNC_A",
    ilk: "0x4b4e432d41000000000000000000000000000000000000000000000000000000",
  },
  {
    address: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
    symbol: "LINK",
    gemJoin: "0xdFccAf8fDbD2F4805C174f856a317765B49E4a50",
    ilkDescription: "LINK_A",
    ilk: "0x4c494e4b2d410000000000000000000000000000000000000000000000000000",
  },
  {
    address: "0xBBbbCA6A901c926F240b89EacB641d8Aec7AEafD",
    symbol: "LRC",
    gemJoin: "0x6C186404A7A238D3d6027C0299D1822c1cf5d8f1",
    ilkDescription: "LRC_A",
    ilk: "0x4c52432d41000000000000000000000000000000000000000000000000000000",
  },
  {
    address: "0x0F5D2fB29fb7d3CFeE444a200298f468908cC942",
    symbol: "MANA",
    gemJoin: "0xA6EA3b9C04b8a38Ff5e224E7c3D6937ca44C0ef9",
    ilkDescription: "MANA_A",
    ilk: "0x4d414e412d410000000000000000000000000000000000000000000000000000",
  },
  {
    address: "0x8E870D67F660D95d5be530380D0eC0bd388289E1",
    symbol: "USDP",
    gemJoin: "0x7e62B7E279DFC78DEB656E34D6a435cC08a44666",
    ilkDescription: "PAXUSD_A",
    ilk: "0x5041585553442d41000000000000000000000000000000000000000000000000",
  },
  {
    address: "0x0000000000085d4780B73119b644AE5ecd22b376",
    symbol: "TUSD",
    gemJoin: "0x4454aF7C8bb9463203b66C816220D41ED7837f44",
    ilkDescription: "TUSD_A",
    ilk: "0x545553442d410000000000000000000000000000000000000000000000000000",
  },
  {
    address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    symbol: "USDC",
    gemJoin: "0xA191e578a6736167326d05c119CE0c90849E84B7",
    ilkDescription: "USDC_A",
    ilk: "0x555344432d410000000000000000000000000000000000000000000000000000",
  },
  {
    address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    symbol: "USDC",
    gemJoin: "0x2600004fd1585f7270756DDc88aD9cfA10dD0428",
    ilkDescription: "USDC_B",
    ilk: "0x555344432d420000000000000000000000000000000000000000000000000000",
  },
  {
    address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
    symbol: "USDT",
    gemJoin: "0x0Ac6A1D74E84C2dF9063bDDc31699FF2a2BB22A2",
    ilkDescription: "USDT_A",
    ilk: "0x555344542d410000000000000000000000000000000000000000000000000000",
  },
  {
    address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
    symbol: "WBTC",
    gemJoin: "0xBF72Da2Bd84c5170618Fbe5914B0ECA9638d5eb5",
    ilkDescription: "WBTC_A",
    ilk: "0x574254432d410000000000000000000000000000000000000000000000000000",
  },
  {
    address: "0xE41d2489571d322189246DaFA5ebDe1F4699F498",
    symbol: "ZRX",
    gemJoin: "0xc7e8Cd72BDEe38865b4F5615956eF47ce1a7e5D0",
    ilkDescription: "ZRX_A",
    ilk: "0x5a52582d41000000000000000000000000000000000000000000000000000000",
  },
  {
    address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    symbol: "WETH",
    gemJoin: "0x08638eF1A205bE6762A8b935F5da9b700Cf7322c",
    ilkDescription: "ETH_B",
    ilk: "0x4554482d42000000000000000000000000000000000000000000000000000000",
  },
  {
    address: "0xba100000625a3754423978a60c9317c58a424e3D",
    symbol: "BAL",
    gemJoin: "0x4a03Aa7fb3973d8f0221B466EefB53D0aC195f55",
    ilkDescription: "BAL_A",
    ilk: "0x42414c2d41000000000000000000000000000000000000000000000000000000",
  },
  {
    address: "0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e",
    symbol: "YFI",
    gemJoin: "0x3ff33d9162aD47660083D7DC4bC02Fb231c81677",
    ilkDescription: "YFI_A",
    ilk: "0x5946492d41000000000000000000000000000000000000000000000000000000",
  },
  {
    address: "0x056Fd409E1d7A124BD7017459dFEa2F387b6d5Cd",
    symbol: "GUSD",
    gemJoin: "0xe29A14bcDeA40d83675aa43B72dF07f649738C8b",
    ilkDescription: "GUSD_A",
    ilk: "0x475553442d410000000000000000000000000000000000000000000000000000",
  },
  {
    address: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
    symbol: "UNI",
    gemJoin: "0x3BC3A58b4FC1CbE7e98bB4aB7c99535e8bA9b8F1",
    ilkDescription: "UNI_A",
    ilk: "0x554e492d41000000000000000000000000000000000000000000000000000000",
  },
  {
    address: "0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D",
    symbol: "renBTC",
    gemJoin: "0xFD5608515A47C37afbA68960c1916b79af9491D0",
    ilkDescription: "RENBTC_A",
    ilk: "0x52454e4254432d41000000000000000000000000000000000000000000000000",
  },
  {
    address: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
    symbol: "AAVE",
    gemJoin: "0x24e459F61cEAa7b1cE70Dbaea938940A7c5aD46e",
    ilkDescription: "AAVE_A",
    ilk: "0x414156452d410000000000000000000000000000000000000000000000000000",
  },
  {
    address: "0xA478c2975Ab1Ea89e8196811F51A7B7Ade33eB11",
    symbol: "UNI-V2",
    gemJoin: "0x2502F65D77cA13f183850b5f9272270454094A08",
    ilkDescription: "UNIV2DAIETH_A",
    ilk: "0x554e4956324441494554482d4100000000000000000000000000000000000000",
  },
  {
    address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    symbol: "USDC",
    gemJoin: "0x0A59649758aa4d66E25f08Dd01271e891fe52199",
    ilkDescription: "PSM_USDC_A",
    ilk: "0x50534d2d555344432d4100000000000000000000000000000000000000000000",
  },
  {
    address: "0xBb2b8038a1640196FbE3e38816F3e67Cba72D940",
    symbol: "UNI-V2",
    gemJoin: "0xDc26C9b7a8fe4F5dF648E314eC3E6Dc3694e6Dd2",
    ilkDescription: "UNIV2WBTCETH_A",
    ilk: "0x554e495632574254434554482d41000000000000000000000000000000000000",
  },
  {
    address: "0xB4e16d0168e52d35CaCD2c6185b44281Ec28C9Dc",
    symbol: "UNI-V2",
    gemJoin: "0x03Ae53B33FeeAc1222C3f372f32D37Ba95f0F099",
    ilkDescription: "UNIV2USDCETH_A",
    ilk: "0x554e495632555344434554482d41000000000000000000000000000000000000",
  },
  {
    address: "0xAE461cA67B15dc8dc81CE7615e0320dA1A9aB8D5",
    symbol: "UNI-V2",
    gemJoin: "0xA81598667AC561986b70ae11bBE2dd5348ed4327",
    ilkDescription: "UNIV2DAIUSDC_A",
    ilk: "0x554e495632444149555344432d41000000000000000000000000000000000000",
  },
  {
    address: "0x0d4a11d5EEaaC28EC3F61d100daF4d40471f1852",
    symbol: "UNI-V2",
    gemJoin: "0x4aAD139a88D2dd5e7410b408593208523a3a891d",
    ilkDescription: "UNIV2ETHUSDT_A",
    ilk: "0x554e495632455448555344542d41000000000000000000000000000000000000",
  },
  {
    address: "0xa2107FA5B38d9bbd2C461D6EDf11B11A50F6b974",
    symbol: "UNI-V2",
    gemJoin: "0xDae88bDe1FB38cF39B6A02b595930A3449e593A6",
    ilkDescription: "UNIV2LINKETH_A",
    ilk: "0x554e4956324c494e4b4554482d41000000000000000000000000000000000000",
  },
  {
    address: "0xd3d2E2692501A5c9Ca623199D38826e513033a17",
    symbol: "UNI-V2",
    gemJoin: "0xf11a98339FE1CdE648e8D1463310CE3ccC3d7cC1",
    ilkDescription: "UNIV2UNIETH_A",
    ilk: "0x554e495632554e494554482d4100000000000000000000000000000000000000",
  },
  {
    address: "0x231B7589426Ffe1b75405526fC32aC09D44364c4",
    symbol: "UNI-V2",
    gemJoin: "0xD40798267795Cbf3aeEA8E9F8DCbdBA9b5281fcC",
    ilkDescription: "UNIV2WBTCDAI_A",
    ilk: "0x554e495632574254434441492d41000000000000000000000000000000000000",
  },
  {
    address: "0xDFC14d2Af169B0D36C4EFF567Ada9b2E0CAE044f",
    symbol: "UNI-V2",
    gemJoin: "0x42AFd448Df7d96291551f1eFE1A590101afB1DfF",
    ilkDescription: "UNIV2AAVEETH_A",
    ilk: "0x554e495632414156454554482d41000000000000000000000000000000000000",
  },
  {
    address: "0xB20bd5D04BE54f870D5C0d3cA85d82b34B836405",
    symbol: "UNI-V2",
    gemJoin: "0xAf034D882169328CAf43b823a4083dABC7EEE0F4",
    ilkDescription: "UNIV2DAIUSDT_A",
    ilk: "0x554e495632444149555344542d41000000000000000000000000000000000000",
  },
  {
    address: "0x10b2aA5D77Aa6484886d8e244f0686aB319a270d",
    symbol: "RWA001",
    gemJoin: "0x476b81c12Dc71EDfad1F64B9E07CaA60F4b156E2",
    ilkDescription: "RWA001_A",
    ilk: "0x5257413030312d41000000000000000000000000000000000000000000000000",
  },
  {
    address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    symbol: "WETH",
    gemJoin: "0xF04a5cC80B1E94C69B48f5ee68a08CD2F09A7c3E",
    ilkDescription: "ETH_C",
    ilk: "0x4554482d43000000000000000000000000000000000000000000000000000000",
  },
  {
    address: "0xAAA760c2027817169D7C8DB0DC61A2fb4c19AC23",
    symbol: "RWA002",
    gemJoin: "0xe72C7e90bc26c11d45dBeE736F0acf57fC5B7152",
    ilkDescription: "RWA002_A",
    ilk: "0x5257413030322d41000000000000000000000000000000000000000000000000",
  },
  {
    address: "0x07F0A80aD7AeB7BfB7f139EA71B3C8f7E17156B9",
    symbol: "RWA003",
    gemJoin: "0x1Fe789BBac5b141bdD795A3Bc5E12Af29dDB4b86",
    ilkDescription: "RWA003_A",
    ilk: "0x5257413030332d41000000000000000000000000000000000000000000000000",
  },
  {
    address: "0x873F2101047A62F84456E3B2B13df2287925D3F9",
    symbol: "RWA004",
    gemJoin: "0xD50a8e9369140539D1c2D113c4dC1e659c6242eB",
    ilkDescription: "RWA004_A",
    ilk: "0x5257413030342d41000000000000000000000000000000000000000000000000",
  },
  {
    address: "0x6DB236515E90fC831D146f5829407746EDdc5296",
    symbol: "RWA005",
    gemJoin: "0xA4fD373b93aD8e054970A3d6cd4Fd4C31D08192e",
    ilkDescription: "RWA005_A",
    ilk: "0x5257413030352d41000000000000000000000000000000000000000000000000",
  },
  {
    address: "0x4EE03cfBF6E784c462839f5954d60f7C2B60b113",
    symbol: "RWA006",
    gemJoin: "0x5E11E34b6745FeBa9449Ae53c185413d6EdC66BE",
    ilkDescription: "RWA006_A",
    ilk: "0x5257413030362d41000000000000000000000000000000000000000000000000",
  },
  {
    address: "0x8E870D67F660D95d5be530380D0eC0bd388289E1",
    symbol: "USDP",
    gemJoin: "0x7bbd8cA5e413bCa521C2c80D8d1908616894Cf21",
    ilkDescription: "PSM_PAX_A",
    ilk: "0x50534d2d5041582d410000000000000000000000000000000000000000000000",
  },
  {
    address: "0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0",
    symbol: "MATIC",
    gemJoin: "0x885f16e177d45fC9e7C87e1DA9fd47A9cfcE8E13",
    ilkDescription: "MATIC_A",
    ilk: "0x4d415449432d4100000000000000000000000000000000000000000000000000",
  },
  {
    address: "0xAbDDAfB225e10B90D798bB8A886238Fb835e2053",
    symbol: "G-UNI",
    gemJoin: "0xbFD445A97e7459b0eBb34cfbd3245750Dba4d7a4",
    ilkDescription: "GUNIV3DAIUSDC1_A",
    ilk: "0x47554e49563344414955534443312d4100000000000000000000000000000000",
  },
  {
    address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
    symbol: "wstETH",
    gemJoin: "0x10CD5fbe1b404B7E19Ef964B63939907bdaf42E2",
    ilkDescription: "WSTETH_A",
    ilk: "0x5753544554482d41000000000000000000000000000000000000000000000000",
  },
  {
    address: "0xD6C7FD4392D328e4a8f8bC50F4128B64f4dB2d4C",
    symbol: "RWA013",
    gemJoin: "0x779D0fD012815D4239BAf75140e6B2971BEd5113",
    ilkDescription: "RWA013_A",
    ilk: "0x5257413031332d41000000000000000000000000000000000000000000000000",
  },
  {
    address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
    symbol: "WBTC",
    gemJoin: "0xfA8c996e158B80D77FbD0082BB437556A65B96E0",
    ilkDescription: "WBTC_B",
    ilk: "0x574254432d420000000000000000000000000000000000000000000000000000",
  },
  {
    address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
    symbol: "WBTC",
    gemJoin: "0x7f62f9592b823331E012D3c5DdF2A7714CfB9de2",
    ilkDescription: "WBTC_C",
    ilk: "0x574254432d430000000000000000000000000000000000000000000000000000",
  },
  {
    address: "0x056Fd409E1d7A124BD7017459dFEa2F387b6d5Cd",
    symbol: "GUSD",
    gemJoin: "0x79A0FA989fb7ADf1F8e80C93ee605Ebb94F7c6A5",
    ilkDescription: "PSM_GUSD_A",
    ilk: "0x50534d2d475553442d4100000000000000000000000000000000000000000000",
  },
  {
    address: "0x50379f632ca68D36E50cfBC8F78fe16bd1499d1e",
    symbol: "G-UNI",
    gemJoin: "0xA7e4dDde3cBcEf122851A7C8F7A55f23c0Daf335",
    ilkDescription: "GUNIV3DAIUSDC2_A",
    ilk: "0x47554e49563344414955534443322d4100000000000000000000000000000000",
  },
  {
    address: "0x06325440D014e39736583c165C2963BA99fAf14E",
    symbol: "steCRV",
    gemJoin: "0x82D8bfDB61404C796385f251654F6d7e92092b5D",
    ilkDescription: "CRVV1ETHSTETH_A",
    ilk: "0x435256563145544853544554482d410000000000000000000000000000000000",
  },
  {
    address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
    symbol: "wstETH",
    gemJoin: "0x248cCBf4864221fC0E840F29BB042ad5bFC89B5c",
    ilkDescription: "WSTETH_B",
    ilk: "0x5753544554482d42000000000000000000000000000000000000000000000000",
  },
  {
    address: "0xb9737098b50d7c536b6416dAeB32879444F59fCA",
    symbol: "RWA008",
    gemJoin: "0x56eDD5067d89D4E65Bf956c49eAF054e6Ff0b262",
    ilkDescription: "RWA008_A",
    ilk: "0x5257413030382d41000000000000000000000000000000000000000000000000",
  },
  {
    address: "0x8b9734bbaA628bFC0c9f323ba08Ed184e5b88Da2",
    symbol: "RWA009",
    gemJoin: "0xEe0FC514280f09083a32AE906cCbD2FAc4c680FA",
    ilkDescription: "RWA009_A",
    ilk: "0x5257413030392d41000000000000000000000000000000000000000000000000",
  },
  {
    address: "0x078fb926b041a816FaccEd3614Cf1E4bc3C723bD",
    symbol: "RWA007",
    gemJoin: "0x476aaD14F42469989EFad0b7A31f07b795FF0621",
    ilkDescription: "RWA007_A",
    ilk: "0x5257413030372d41000000000000000000000000000000000000000000000000",
  },
  {
    address: "0xae78736Cd615f374D3085123A210448E74Fc6393",
    symbol: "rETH",
    gemJoin: "0xC6424e862f1462281B0a5FAc078e4b63006bDEBF",
    ilkDescription: "RETH_A",
    ilk: "0x524554482d410000000000000000000000000000000000000000000000000000",
  },
  {
    address: "0x6810e776880C02933D47DB1b9fc05908e5386b96",
    symbol: "GNO",
    gemJoin: "0x7bD3f01e24E0f0838788bC8f573CEA43A80CaBB5",
    ilkDescription: "GNO_A",
    ilk: "0x474e4f2d41000000000000000000000000000000000000000000000000000000",
  },
  {
    address: "0x20C72C1fdd589C4Aaa8d9fF56a43F3B17BA129f8",
    symbol: "RWA010",
    gemJoin: "0xde2828c3F7B2161cF2a1711edc36c73C56EA72aE",
    ilkDescription: "RWA010_A",
    ilk: "0x5257413031302d41000000000000000000000000000000000000000000000000",
  },
  {
    address: "0x0b126F85285d1786F52FC911AfFaaf0d9253e37a",
    symbol: "RWA011",
    gemJoin: "0x9048cb84F46e94Ff312DcC50f131191c399D9bC3",
    ilkDescription: "RWA011_A",
    ilk: "0x5257413031312d41000000000000000000000000000000000000000000000000",
  },
  {
    address: "0x3c7f1379B5ac286eB3636668dEAe71EaA5f7518c",
    symbol: "RWA012",
    gemJoin: "0x75646F68B8c5d8F415891F7204978Efb81ec6410",
    ilkDescription: "RWA012_A",
    ilk: "0x5257413031322d41000000000000000000000000000000000000000000000000",
  },
  {
    address: "0x75dCa04C4aCC1FfB0AEF940e5b49e2C17416008a",
    symbol: "RWA014",
    gemJoin: "0xAd722E51569EF41861fFf5e11942a8E07c7C309e",
    ilkDescription: "RWA014_A",
    ilk: "0x5257413031342d41000000000000000000000000000000000000000000000000",
  },
  {
    address: "0xf5E5E706EfC841BeD1D24460Cd04028075cDbfdE",
    symbol: "RWA015",
    gemJoin: "0x8938988f7B368f74bEBdd3dcd8D6A3bd18C15C0b",
    ilkDescription: "RWA015_A",
    ilk: "0x5257413031352d41000000000000000000000000000000000000000000000000",
  },
] as const
